import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './components/Home';
import Todo from './components/Todo';
import Calendar from './components/Calendar';
import NoPage from './components/NoPage';
import Options from "./components/Options";
import "./index.css";

function App() {
    return (
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Layout />}>
                        <Route index element={<Home />} />
                        <Route path="/Home" element={<Home />} />
                        <Route path="/Todo" element={<Todo />} />
                        <Route path="/Calendar" element={<Calendar />} />
                        <Route path="/Options" element={<Options />} />
                        <Route path="*" element={<NoPage />} />
                    </Route>
                </Routes>
            </BrowserRouter>
    )
}
export default App;
